import angular from 'angular';
import csmCommonWeb from 'csm-common-web';
import booksService from '../../util/BooksSvc/BooksSvc';
import donationsReportTemplate from './donationsReport.template.html';

export default angular
  .module('books.ui.donationsReport', [csmCommonWeb, booksService])
  .directive('donationsReport', donationsReportDirective).name;

/*******************************************************************************
 * Directive
 *******************************************************************************/
/* @ngInject */ function donationsReportDirective(
  BooksSvc,
  SERVER,
  BusyScreen
) {
  return {
    template: donationsReportTemplate,
    controller: controller,
    controllerAs: '$ctrl',
    scope: {
      fundName: '=', // Name of the accountName in the accountList array
      fundraiserLabel: '@' // Name for the fundraisers selection label
    }
  };
}

/*******************************************************************************
 * Controller
 *******************************************************************************/
/* @ngInject */ function controller($injector, $scope) {
  const $svcs = { $ctrl: this, $injector, $scope };

  $injector.invoke(initCtrl, null, Object.assign($svcs, { $svcs }));
}

/*******************************************************************************
 * initCtrl */
/**
 * Initializes the controller object.
 *******************************************************************************/
/* @ngInject */ function initCtrl($injector, $ctrl, $scope, $svcs) {
  Object.assign($ctrl, {
    categories: [],
    categoryID: 0,
    classID: 0,
    data: {},

    /*------------------------------------------------*/
    /* Static array for the donation source dropdown. */
    /*------------------------------------------------*/
    donationSource: [
      { name: 'All', code: '' },
      { name: 'Web Store', code: 'WS' },
      { name: 'Non-Web Store', code: 'NW' }
    ],

    fundName: $scope.fundName,
    fundraiserLabel: $scope.fundraiserLabel,
    fundraisersList: [],
    itemDonations: [],
    itemID: 0,
    org: null,

    /*---------------------------------------------*/
    /* Sets the default report format on page load */
    /*---------------------------------------------*/
    req: {
      categoryID: null,
      classID: null,
      itemID: null,
      entityID: null,
      reportFormat: 'PDF',
      source: null,
      startDate: null,
      endDate: null
    },

    /*-----------------------------------------------------------*/
    /* Control object for resetting the entity to "All Entities" */
    /*-----------------------------------------------------------*/
    resetEntity: {},

    /*-----------------------------------------------------------------*/
    /* Works with the CSMValidator directive to validate the typeahead */
    /* for the entities is populated when a "name" option is selected. */
    /*-----------------------------------------------------------------*/
    valOption: {},

    /*-----------*/
    /* Functions */
    /*-----------*/
    $onInit: $injector.invoke(onInit, null, $svcs),
    filterItems: $injector.invoke(filterItems, null, $svcs),
    resetFilters: $injector.invoke(resetFilters, null, $svcs),
    validateInput: $injector.invoke(validateInput, null, $svcs)
  });
}

/*******************************************************************************
 * filterItems */
/**
 * Filters the list of donation items based on the categoryID that is selected.
 *******************************************************************************/
/* @ngInject */ function filterItems($ctrl) {
  return function (item) {
    let allCategories = !$ctrl.req.categoryID;
    let allItems = !item.id;

    return (
      allCategories || allItems || $ctrl.req.categoryID === item.categoryID
    );
  };
}

/*******************************************************************************
 * $onInit */
/**
 * Once the app has been initialized, we can make our service calls.
 *******************************************************************************/
/* @ngInject */ function onInit($ctrl, BooksSvc, BusyScreen, SERVER) {
  return function () {
    BooksSvc.getClassInfoList(NaN, true).then(function (resp) {
      resp.data.sort(function (a, b) {
        return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
      });
      $ctrl.fundraisersList = [{ id: 0, name: $ctrl.fundName }].concat(
        resp.data
      );

      BooksSvc.getOrganization().then(function (resp) {
        $ctrl.org = resp.data;
      });

      BooksSvc.getItemList(SERVER.BooksDBConstants.IT_DONATION).then(
        function (resp) {
          $ctrl.itemDonations = [
            { id: 0, shortDescription: 'All Donations' }
          ].concat(resp.data);

          /*---------------------------------------------------------------*/
          /* Creates a new categories array from the donations array to    */
          /* filter the donations dropdown based on the category selected. */
          /*---------------------------------------------------------------*/
          var catIDs = [];
          var categories = [];
          for (var i = 0; i < resp.data.length; i++)
            if (catIDs.indexOf(resp.data[i].categoryID) == -1) {
              catIDs.push(resp.data[i].categoryID);
              categories.push({
                id: resp.data[i].categoryID,
                name: resp.data[i].category
              });
            }
          $ctrl.categories = [{ id: 0, name: 'All Item Categories' }].concat(
            categories
          );

          $ctrl.resetFilters();

          /*------------------------------------------------------------*/
          /* BusyScreen is set to false here because the                */
          /* resetFilters() function is called at the end of controller */
          /*------------------------------------------------------------*/
          BusyScreen.setBusy(false);
        }
      );
    });
  };
}

/*******************************************************************************
 * resetFilters */
/**
 * Resets values on button click and sets the values on page load.
 *******************************************************************************/
/* @ngInject */ function resetFilters($ctrl) {
  return function () {
    $ctrl.req.source = ''; /* Donation Source */
    $ctrl.req.classID = 0; /* Fundraisers */
    $ctrl.req.categoryID = 0; /* Categories */
    $ctrl.req.itemID = 0; /* Donations */

    /*------------------------------------------*/
    /* Works with the entitySelection directive */
    /* to reset the Entites to "All Entities"   */
    /*------------------------------------------*/
    $ctrl.resetEntity.reset();
  };
}

/*******************************************************************************
 * validateInput */
/**
 * Validate criteria before generating the report.
 *******************************************************************************/
/* @ngInject */ function validateInput($ctrl) {
  return function () {
    return $ctrl.valOption.validate();
  };
}
